import React from "react";
import { consumeApi, setLiteral, validateEmail } from "../js/helpers.js";
import {
  Page,
  Navbar,
  NavRight,
  Link,
  LoginScreen,
  LoginScreenTitle,
  List,
  ListInput,
  Button,
  Row,
  Col,
  f7,
  Block,
} from "framework7-react";
import { capital, digit } from "../js/password.js";
import Framework7, { Dom7, getDevice } from "framework7";
export default class Nregistro2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: props.userData.email || "",
      hideEmail: this.getHiddenEmail(props.userData.email),
      sPass: "",
      sTextPass: "",
      bValidatePass: false,
      bSamePass: false,
      lsLiterales: props.lsLiterales || {},
      configDomain: props.configDomain || {},
      userInformation: props.userData || {},
      idCli: props.clienteID,
    };
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.$$ = Dom7;
  }
  // Dentro de tu componente Nregistro2:
  handlePasswordChange = (e) => {
    const value = String(e.target.value || ""); // Fuerza la conversión a string
    this.setState({ password: value }, this.validatePassword);
  };
  getHiddenEmail = (email) => {
    if (!email) return "";
    const emailSplit = email.split("@");
    const starEmail = emailSplit[0].substring(0, 2);
    const finishEmail = emailSplit[0].substring(
      emailSplit[0].length - 2,
      emailSplit[0].length
    );
    return starEmail + "*****" + finishEmail + "@" + emailSplit[1];
  };

  validatePassword = (e) => {
    e.preventDefault();
    const pass = e.target.value;
    var bCapital, bSpecial, bNumber, blength;

    if (capital(pass)) {
      this.$$("#capital").addClass("charPass");
      bCapital = true;
    } else {
      this.$$("#capital").removeClass("charPass");
      bCapital = false;
    }

    // if (specialChar(pass)) {
    //   this.$$("#specialChar").addClass('charPass');
    //   bSpecial = true;
    // }
    // else {
    //   this.$$("#specialChar").removeClass('charPass');
    //   bSpecial = false;
    // }

    if (digit(pass)) {
      this.$$("#number").addClass("charPass");
      bNumber = true;
    } else {
      this.$$("#number").removeClass("charPass");
      bNumber = false;
    }

    if (pass.length >= 8) {
      this.$$("#charactes").addClass("charPass");
      blength = true;
    } else {
      this.$$("#charactes").removeClass("charPass");
      blength = false;
    }

    this.setState({ sPass: pass });

    if (bCapital && bNumber && blength) {
      this.setState({ bValidatePass: true });
    }
  };

  validateSamePass = (e) => {
    const samePass = e.target.value === this.state.sPass;
    this.setState({
      sTextPass: samePass ? "" : setLiteral(this.state.lsLiterales, 101043),
      bSamePass: samePass,
    });
  };

  showPassword = (nameInput, nameButton) => {
    const input = this.$$(`input[name="${nameInput}"]`);
    const isPassword = input.attr("type") === "password";
    input.attr("type", isPassword ? "text" : "password");
    this.$$(`#${nameButton}`)
      .children(".icon")
      .html(isPassword ? "eye" : "eye_slash");
  };

  insertUser = async () => {
    if (this.state.bValidatePass && this.state.bSamePass) {
      // 4 mandar validación sms
      var params = {
        company: this.state.configDomain.id_empresa,
        clientId: this.state.idCli.IdCliente,
        name: this.state.userInformation.full_name,
        consecutive: "",
        failedAttempts: "0",
        email: this.state.userInformation.email,
        telephone: this.state.userInformation.personalPhone,
        option: "1",
        applicationType: "1",
      };

      f7.dialog.preloader();
      //1. ir por consecutivo opcion 1
      const method = "/miapp/User/InsertUser/";
      const resCons = await consumeApi("POST", method, JSON.stringify(params));
      if (!resCons.includes("error")) {
        var sCons = JSON.parse(resCons);
        const iCons = parseInt(sCons.IdConsecutivo) + 1;

        //2. insertar usuario con detalle opcion 5
        params.consecutive = String(iCons);
        params.option = "5";
        const insFullUser = await consumeApi(
          "POST",
          method,
          JSON.stringify(params)
        );
        if (typeof insFullUser == "object") {
          const methodUpdate = "/miapp/User/UpdateUser/";

          params = JSON.stringify({
            company: this.state.configDomain.id_empresa,
            clientId: this.state.idCli.IdCliente,
            login: this.state.username,
            password: this.state.sPass,
            option: "1",
            applicationType: "1",
          });

          const insLogin = await consumeApi("POST", methodUpdate, params);

          if (!insLogin.includes("error")) {
            this.sendSMS(insFullUser.telephone);
          } else {
            f7.dialog.close();
            f7.dialog.alert("Error");
          }
        } else {
          f7.dialog.close();
          f7.dialog.alert("Error");
        }
      } else {
        f7.dialog.close();
        f7.dialog.alert("Error");
      }
    }
  };

  sendSMS = async (telephone) => {
    // Limpiar cualquier diálogo previo
    if (f7.dialog.get()) {
      f7.dialog.close();
    }

    const preloader = f7.dialog.progress("Enviando SMS...");

    try {
      // 1. Obtener información del contrato
      const method = `/core/Contract/ContractByClientId/${this.state.configDomain.id_empresa}/${this.state.idCli.IdCliente}`;
      const contracts = await consumeApi("get", method, "");

      let nup = "";
      if (
        Array.isArray(contracts) &&
        contracts.length > 0 &&
        contracts[0].contractCode
      ) {
        nup = contracts[0].contractCode.split("N")[1] || "";
      }

      // 2. Enviar SMS
      const methodPass = "/miapp/User/SmsSend";
      const params = {
        company: this.state.configDomain.id_empresa,
        language: this.state.configDomain.id_idioma,
        clientId: this.state.idCli.IdCliente,
        login: this.state.username,
        telephone: telephone,
        typeSms: "2",
        application_id: nup,
        applicationType: "1",
      };

      const insSms = await consumeApi(
        "POST",
        methodPass,
        JSON.stringify(params)
      );

      // 3. Verificar respuesta
      if (
        insSms &&
        (insSms === "OK" || (typeof insSms === "object" && !insSms.error))
      ) {
        preloader.close(); // Cerrar explícitamente el preloader actual
        this.validateSMS();
        return; // Salir temprano
      }

      throw new Error(insSms.error || "Respuesta inesperada del servidor");
    } catch (error) {
      console.error("Error en sendSMS:", error);
      preloader.close(); // Asegurar cierre
      f7.dialog.alert(
        "Error",
        `No se pudo enviar el SMS: ${error.message || "Error desconocido"}`
      );
    } finally {
      // Doble seguro para cerrar
      if (f7.dialog.get()) {
        f7.dialog.close();
      }
    }
  };
  validateSMS = async () => {
    // 1. Cerrar y limpiar cualquier diálogo previo
    if (window.activeSMSDialog) {
      window.activeSMSDialog.close();
      await new Promise((resolve) => setTimeout(resolve, 50));
    }

    // 2. Crear nuevo diálogo
    return new Promise((resolve) => {
      window.activeSMSDialog = f7.dialog.create({
        title: setLiteral(this.state.lsLiterales, 101053),
        text: `
          <div class="sms-validation-dialog">
            ${setLiteral(this.state.lsLiterales, 101054)}
            <br>
            <div class="text-center">
              ${setLiteral(this.state.lsLiterales, 101055)}
            </div>
            <input id="smsValidationCode" type="text" class="dialog-input" placeholder="Código SMS">
          </div>
        `,
        cssClass: "sms-dialog-fixed",
        buttons: [
          {
            text: setLiteral(this.state.lsLiterales, 101060),
            keyCodes: [13], // Enter key
            onClick: async (dialog) => {
              const code = Dom7("#smsValidationCode").val().trim();
              if (!code) {
                f7.dialog.alert("Error", "Por favor ingrese el código SMS");
                return false;
              }
              await this.validateSMSCode(code, dialog);
              resolve(true);
              return false;
            },
          },
          {
            text: setLiteral(this.state.lsLiterales, 101097),
            onClick: () => {
              resolve(false);
              this.sendSMS(this.state.userInformation.telephone);
            },
          },
        ],
        on: {
          opened: () => {
            Dom7("#smsValidationCode").focus();
            // Forzar redibujado del componente
            setTimeout(() => {}, 100);
          },
          close: () => {
            return false; // Previene cierre automático
          },
          closed: () => {
            window.activeSMSDialog = null;
          },
        },
        destroyOnClose: false,
        closeByOutsideClick: false,
        closeOnEscape: false,
      });

      // 3. Apertura controlada del diálogo
      setTimeout(() => {
        if (!window.activeSMSDialog.opened) {
          window.activeSMSDialog.open();
        }
      }, 150);
    });
  };

  validateSMSCode = async (code, dialog) => {
    f7.dialog.preloader("Validando código...");

    try {
      const methodValidate = "/miapp/User/CustomerBySms";
      const params = {
        company: this.state.configDomain.id_empresa,
        clientId: this.state.idCli.IdCliente,
        sms: code,
        option: "2",
        applicationType: "1",
      };

      const response = await consumeApi(
        "POST",
        methodValidate,
        JSON.stringify(params)
      );

      if (response && !response.error) {
        const methodActive = "/miapp/User/UpdateSmsUser";
        const activeParams = {
          company: this.state.configDomain.id_empresa,
          clientId: this.state.idCli.IdCliente,
          sms: code,
          status: "1",
          applicationType: "1",
        };

        const activeResponse = await consumeApi(
          "POST",
          methodActive,
          JSON.stringify(activeParams)
        );

        if (activeResponse && !activeResponse.error) {
          this.setState({
            loginScreenOpened: true,
            popupUser: false,
            popupPassword: false,
          });
          dialog.close();
          f7.dialog.alert(
            "Validación exitosa",
            "Su número ha sido verificado correctamente"
          );
        } else {
          throw new Error("Error al activar SMS");
        }
      } else {
        throw new Error("Código SMS inválido");
      }
    } catch (error) {
      console.error("Error validando SMS:", error);
      f7.dialog.alert(
        setLiteral(this.state.lsLiterales, 101056),
        "El código es incorrecto"
      );
    } finally {
      f7.dialog.close();
    }
  };

  render() {
    return (
      <Page name="home" className="mainImg">
        <LoginScreen className="LOGIN3" opened={true}>
          <Navbar id="NavReg" transparent={true}>
            <NavRight>
              <Link onClick={() => this.props.f7router.back()}>X</Link>
            </NavRight>
          </Navbar>
          <LoginScreenTitle className="MC">
            Bienvenido a <a>MI CUOTA FÁCIL</a>
            <h1 id="titulo">REGISTRO</h1>
          </LoginScreenTitle>
          <List noHairlinesMd className="containerR2">
            <Row className="aligner2">
              <Col
                width="90"
                xlarge="95"
                large="65"
                medium="65"
                small="90"
                xsmall="90"
              >
                <ListInput
                  outline
                  label={setLiteral(this.state.lsLiterales, 101036)}
                  placeholder="Correo electrónico"
                  type="text"
                  maxlength="10"
                  autocomplete="false"
                  value={this.props.userData.email}
                  disabled
                />
              </Col>
              <Col width="10"></Col>
            </Row>
            <Row className="aligner2">
              <Col
                width="90"
                xlarge="95"
                large="65"
                medium="65"
                small="90"
                xsmall="90"
              >
                <ListInput
                  outline
                  label={setLiteral(this.state.lsLiterales, 101037)}
                  placeholder="Contraseña"
                  onChange={this.validatePassword}
                  type="password"
                  name="password"
                />
                <Button
                  id="btnShowPassRegister"
                  iconF7="eye_slash"
                  size="5"
                  onClick={() =>
                    this.showPassword("password", "btnShowPassRegister")
                  }
                />
              </Col>
            </Row>
            <Row className="aligner4">
              <Col id="charactes" width="33.33">
                {setLiteral(this.state.lsLiterales, 101033)}
              </Col>
              <Col id="capital" width="33.33">
                {setLiteral(this.state.lsLiterales, 101034)}
              </Col>
              <Col id="number" width="33.33">
                {setLiteral(this.state.lsLiterales, 101035)}
              </Col>
            </Row>
            <Row className="aligner2">
              <Col
                width="90"
                xlarge="95"
                large="65"
                medium="65"
                small="90"
                xsmall="90"
              >
                <ListInput
                  outline
                  label={setLiteral(this.state.lsLiterales, 101039)}
                  placeholder="Confirmar contraseña"
                  validate
                  onChange={this.validateSamePass}
                  type="password"
                />
              </Col>
              <Col width="10"></Col>
              <Col id="samePass" width="65" style={{ color: "red" }}>
                {this.state.sTextPass}
              </Col>
            </Row>
            <Block>
              <Row className="aligner3">
                <Col width="30"></Col>
                <Col
                  width="35"
                  xlarge="25"
                  large="25"
                  medium="25"
                  small="35"
                  xsmall="35"
                >
                  <Button fill onClick={this.insertUser}>
                    {setLiteral(this.state.lsLiterales, 101070)}
                  </Button>
                </Col>
              </Row>
            </Block>
          </List>
        </LoginScreen>
      </Page>
    );
  }
}
